import { render, staticRenderFns } from "./FfgChat.vue?vue&type=template&id=6df74269&"
import script from "./FfgChat.vue?vue&type=script&lang=js&"
export * from "./FfgChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports